import { isFalsy } from '../../Helpers';

/**
 * Takes unformatted large integer and applies comma separation
 * @function addCommasToNumber
 * @param {number} value
 * @return {string} Formatted number => string
 * @example addCommasToNumber(10000) => 10,000
 */
const addCommasToNumber = num => {
  if (isFalsy(num)) return 0;
  return num
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export default addCommasToNumber;
